import {
  Box,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  Typography,
  useTheme,
} from '@mui/material';
import { GreyButton, StyledOutlinedInput, SuccessButton } from 'components/atoms';
import React, { ChangeEvent, useState } from 'react';
import { FaLock } from 'react-icons/fa';
import { FaCheck } from 'react-icons/fa6';
import { IoMdClose } from 'react-icons/io';

import { ChangePasswordProps } from './types';

export const ChangePasswordModal = ({ onClose, open, onSubmit }: ChangePasswordProps) => {
  const theme = useTheme();
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState('');

  const handleNewPasswordChange = ({
    target: { value: newValue },
  }: ChangeEvent<HTMLInputElement>) => {
    setNewPassword(newValue);
  };

  const handleNewPasswordConfirmationChange = ({
    target: { value: newValue },
  }: ChangeEvent<HTMLInputElement>) => {
    setNewPasswordConfirmation(newValue);
  };

  const confirmChange = () => {
    if (newPassword === newPasswordConfirmation) {
      onSubmit(newPassword, newPasswordConfirmation);
    }
  };
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          // @ts-ignore
          backgroundColor: `${theme.palette.grey.light}`,
          display: 'flex',
          justifyContent: 'space-between',
          p: 2,
        }}
      >
        <Box sx={{ display: 'flex', padding: '5px' }}>
          <FaLock
            // @ts-ignore
            color={theme.palette.primary.main}
            style={{ marginTop: 'auto', marginBottom: 'auto', marginRight: '10px' }}
          />
          <Typography
            fontSize={'24px'}
            fontWeight={700}
            component="div"
            sx={{ marginTop: 'auto', marginBottom: 'auto' }}
          >
            Password
          </Typography>
        </Box>
        <IconButton aria-label="close" onClick={onClose} sx={{ marginRight: 5 }}>
          <IoMdClose />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <FormControl required={true} style={{ width: '100%', marginBottom: '18px' }}>
          <StyledOutlinedInput type="password" onChange={handleNewPasswordChange} />
          <InputLabel sx={{ background: theme.palette.background.paper }}>
            New Password
          </InputLabel>
        </FormControl>
        <FormControl required={true} style={{ width: '100%' }}>
          <StyledOutlinedInput
            type="password"
            onChange={handleNewPasswordConfirmationChange}
          />
          <InputLabel sx={{ background: theme.palette.background.paper }}>
            Confirm Password
          </InputLabel>
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ margin: 'auto' }}>
        <ButtonGroup size="large" variant="contained">
          <GreyButton
            aria-label="close"
            onClick={onClose}
            sx={{ paddingLeft: '48px', paddingRight: '48px' }}
          >
            <IoMdClose style={{ fontSize: '2rem' }} />
          </GreyButton>
          <SuccessButton
            aria-label="close"
            onClick={confirmChange}
            sx={{ paddingLeft: '48px', paddingRight: '48px' }}
          >
            <FaCheck style={{ fontSize: '2rem' }} />
          </SuccessButton>
        </ButtonGroup>
      </DialogActions>
    </Dialog>
  );
};
